import React, { ReactNode } from 'react';
import styles from './FloList.module.css';
import { FloComponentProps } from 'components';
import { Row, Col } from 'react-bootstrap';
import classnames from 'classnames';

export interface ListHeaderProps extends FloComponentProps {
  children: ReactNode;
}

export const ListHeader: React.FC<ListHeaderProps> = React.memo(({children}) => (
  <Row className={styles.header}>{children}</Row>
))

export interface ListRowProps extends FloComponentProps {
  children: ReactNode;
}

export const ListRow: React.FC<ListRowProps> = React.memo(({children, className}) => (
  <Row className={classnames(styles.locationRow, className)}>{children}</Row>
))

export interface ListBodyProps extends FloComponentProps {
  children: ReactNode;
}

export const ListBody: React.FC<ListBodyProps> = React.memo(({children}) => (
  <Row className={styles.listBody}>
    <Col xs="12">
      {children}
    </Col>
  </Row>
))

export interface FloListProps extends FloComponentProps {
  children: ReactNode;
}

export class FloList extends React.PureComponent<FloListProps> {
  static Body: React.FC<ListBodyProps>;
  static Row: React.FC<ListRowProps>;
  static Header: React.FC<ListHeaderProps>;

  render() {
    return <>{this.props.children}</>
  }
}

FloList.Body = ListBody;
FloList.Row = ListRow;
FloList.Header = ListHeader;
